import React from 'react';
//import React, { useContext } from 'react';
//import { ShopperContext } from '../context/shopper';
import { useStyles } from "../hooks/useStyles";

export const CategoryHeader = ( {categoryText, columnCount=5} ) => {
  const { altBorderTopColor } = useStyles();

  return (
    <tr style={altBorderTopColor} className="fw-bold" key={categoryText}>
      <th colSpan={columnCount} >
        {categoryText}
      </th>
    </tr>
  )
}

export default CategoryHeader